import React from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Library page placeholder
 * TODO: Implement stage library functionality
 */
export default function LibraryPage() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center justify-center w-screen h-screen bg-background text-foreground">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">Stage Library</h1>
        <p className="text-muted-foreground mb-8">This feature is coming soon...</p>
        <button
          onClick={() => navigate('/designer')}
          className="px-6 py-3 bg-primary text-primary-foreground rounded-md hover:opacity-90 transition-opacity"
        >
          Return to Designer
        </button>
      </div>
    </div>
  );
}
